import { Revision } from './revision.model';
import { UUID } from './uuid.model';
import { WalletAccessRole, WalletState } from './wallet.model';

export interface WalletAccessDto<T = WalletAccessRole> {
  accountId: UUID;
  role: T;
}

export type WalletAccesses = [
  WalletAccessDto<WalletAccessRole.Owner>,
  ...WalletAccessDto<WalletAccessRole.User>[],
];

export interface WalletDto extends Revision {
  readonly id: UUID;
  name: string;
  state: WalletState;
  walletAccesses: WalletAccesses;
}

export type WalletPostBody = Pick<WalletDto, 'name' | 'walletAccesses'> &
  Partial<Pick<WalletDto, 'state'>>;
export type UpdateWalletDto = Partial<WalletPostBody & Pick<WalletDto, 'state'>> &
  Pick<WalletDto, '_version'>;
export const DEFAULT_WALLET_NAME = 'Default';
